import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { RoleService } from '@role/role.service';
import * as RoleActions from '@base/role/store/role.actions';

@Injectable()
export class RoleEffects {
  loadRoles$ = createEffect(() => this.actions$.pipe(
    ofType(RoleActions.GetList),
    mergeMap(() => this.roleService.getRoles().pipe(
        map(roles => RoleActions.GetListSuccess({data: roles})),
        catchError(() => EMPTY)
    ))
  ));

  constructor(
    private actions$: Actions,
    private roleService: RoleService
  ) { }
}
